import { WalletTravelIcon } from './WalletTravelIcon';

/**
 * author: Google
 * id 790A03D3-B40A-468A-A6D6-CA3679FDBD8D
 * name wallet-travel
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet-travel.svg
 * tags
 */
export const CardTravelIcon = WalletTravelIcon;
export default CardTravelIcon